import { DynamicTreeDataSource, NodeOptions } from '../../ui/gzTree/type';
import { API_TYPE_EPS, API_TYPE_MDM, API_TYPE_SVE } from '../../webcomponents.constants';

export enum ServiceTargetIds {
  CORE = 0,
  EPS = 1,
  SVE = 2,
  MDM = 4,
}

export const SERVICE_TARGETS = {
  EPS: {
    id: ServiceTargetIds.EPS,
    name: 'Computers and Virtual Machines',
  },
  SVE: {
    id: ServiceTargetIds.SVE,
    name: 'Cloud Workloads',
  },
  MDM: {
    id: ServiceTargetIds.MDM,
    name: 'Mobile Devices',
  },
};

export const EPS_TYPE_EXCLUDED_FOLDER = 272;
export const SVE_TYPE_EXCLUDED_FOLDER = 608;
export const MDM_TYPE_EXCLUDED_FOLDER = 1040;

export interface NodesOptions {
  showOnlyCompanies: boolean;
  showOnlyManagedByAbove: boolean;
  showExcludedFolder: boolean;
  targetsMode: boolean;
  protectedEntitiesTypes?: number[] | null;
}

export type ServiceTargetId =
  | ServiceTargetIds.CORE
  | ServiceTargetIds.SVE
  | ServiceTargetIds.EPS
  | ServiceTargetIds.MDM;

export type NodesOptionsByServiceTargetId = {
  [key in ServiceTargetId]: NodesOptions;
};

export interface Target {
  protectedEntityId: string;
  company: {
    id: string;
    name: string;
  };
  type: number;
  name: string;
  path: string;
  parentId?: string;
}

export interface SelectedTarget {
  serviceId: ServiceTargetId;
  targets: Target[];
}

export type SelectedTargets = SelectedTarget[];

export interface TargetsViewData {
  companyId: string;
  availableServices: Array<AvailableService>;
  preSelectedTargets?: SelectedTargets;
  treeDataSource?: DynamicTreeDataSource;
  invalidTargetTypes?: Array<number>;
  userHasRightsForNetworkTargets?: boolean;
  showOnlyCompanies?: boolean;
  showOnlyManagedByAbove?: boolean;
  showExcludedFolder?: boolean;
  rootNode?: NodeOptions;
  userMode?: boolean;
  isSingleSelect?: boolean;
}

export interface AvailableService {
  id: number;
  name: string;
}

export type ApiTypeDependency = typeof API_TYPE_EPS | typeof API_TYPE_SVE | typeof API_TYPE_MDM;

export interface TargetsDependencies {
  translateFn: any;
  getUser: Function;
  isCloud: Function;
  api: {
    type?: ApiTypeDependency;
    clients: {
      MDM?: {
        getViewType: Function;
      };
    };
  };
}

export interface Node {
  _id: string;
  company: {
    id: string;
    name: string;
  };
  type: number;
  name: string;
  path: string;
  parentId?: string;
  readOnly?: boolean;
  specifics?: {
    canBeManagedByAbove?: boolean;
    rights?: {
      companyManager?: boolean;
      manageCompanies?: boolean;
      manageNetworks?: boolean;
    };
  };
}

export interface RealNode {
  company: {
    id: string;
    name: string;
  };
  id: string;
  isServiceTarget: boolean;
  path: string;
  readOnly?: boolean;
  type: number;
}

export interface GetRootRequest {
  companyId: string;
}

export interface GetNodeChildrenRequest {
  node: string;
  viewType: number;
  options: NodesOptions;
}

export interface GetNodeChildrenResponse {
  data: Array<Node>;
  realNode: RealNode;
}

export interface ConsoleRequestSettings {
  SVE?: {
    rootNode?: {
      endpoint?: string;
      method?: string;
    };
    childNodes: {
      endpoint?: string;
      method?: string;
    };
  };
  EPS?: {
    rootNode?: {
      endpoint?: string;
      method?: string;
    };
    childNodes?: {
      endpoint?: string;
      method?: string;
    };
  };
  MDM?: {
    rootNode?: {
      endpoint?: string;
      method?: string;
    };
    childNodes?: {
      endpoint?: string;
      method?: string;
    };
  };
}
